import { render, staticRenderFns } from "./im_test.vue?vue&type=template&id=741329b8&scoped=true&"
import script from "./im_test.vue?vue&type=script&lang=ts&"
export * from "./im_test.vue?vue&type=script&lang=ts&"
import style0 from "./im_test.vue?vue&type=style&index=0&id=741329b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741329b8",
  null
  
)

export default component.exports